<template>
    <div class="relative rounded border border-gray-200 bg-white p-6">
        <slot />
    </div>
</template>
